export default {"footerNavColumnTitleWrapper":"xc6t2","footerNavColumnTitleWrapperOpen":"VGUgm","footerNavColumnTitleText":"Xvm32 M3nQ1 UzvkT"};